'use strict';

namespace Core {

    class BookingSummaryBreakdown {
        constructor(){}
    }

    angular
        .module('core')
        .directive('bookingSummaryBreakdown', (): ng.IDirective => {

            return {
                scope: {},
                restrict: 'E',
                bindToController: {
                    title : '@',
                    total : '='
                },
                controller: BookingSummaryBreakdown,
                controllerAs: 'bsb',
                replace: true,
                templateUrl: 'partials/booking/template?name=BookingSummaryBreakdown'
            };

        });

}
